import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ProfileField } from './profileFields';

interface ProfileFieldsListProps {
  fields: ProfileField[];
  isDesktop: boolean;
}

const ProfileFieldsList = ({ fields, isDesktop }: ProfileFieldsListProps) => {
  const { t } = useTranslation();

  return (
    <div className={isDesktop ? 'mb-6 space-y-3' : 'mb-5 space-y-2.5'}>
      {fields.map((field) => (
        <div
          key={field.key}
          className={`flex items-center justify-between rounded-lg border border-border-subtle bg-surface-primary ${
            isDesktop ? 'px-4 py-3' : 'px-3 py-2.5'
          }`}
        >
          <div className={`flex items-center ${isDesktop ? 'gap-3' : 'gap-2'}`}>
            <span
              className={`font-body text-foreground-primary ${isDesktop ? 'text-sm' : 'text-[13px]'}`}
            >
              {field.label}
            </span>
            <span
              className={`rounded-full font-medium ${
                isDesktop ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]'
              } ${
                field.required
                  ? 'bg-red-100 text-red-700'
                  : 'bg-gray-100 text-gray-600'
              }`}
            >
              {field.required
                ? t('profileCompletion.required')
                : t('profileCompletion.optional')}
            </span>
          </div>
          <div>
            {field.isSet ? (
              <div
                className={`flex items-center justify-center rounded-full bg-green-100 ${isDesktop ? 'h-6 w-6' : 'h-5 w-5'}`}
              >
                <Check
                  className={`text-green-600 ${isDesktop ? 'h-4 w-4' : 'h-3 w-3'}`}
                />
              </div>
            ) : (
              <div
                className={`flex items-center justify-center rounded-full bg-red-100 ${isDesktop ? 'h-6 w-6' : 'h-5 w-5'}`}
              >
                <X
                  className={`text-red-600 ${isDesktop ? 'h-4 w-4' : 'h-3 w-3'}`}
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProfileFieldsList;
